import type { JSX, ReactNode } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styled from 'styled-components';

interface TitleWrapperProps {
  fullWidth?: boolean;
}

const TitleWrapper = styled.div<TitleWrapperProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  background-color: #fff;
`;

const Titles = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  gap: 8px;
  flex-wrap: nowrap;

  @media only screen and (max-width: 700px) {
    flex-wrap: wrap;
  }
`;

const Title = styled.h2`
  color: var(--Text-text-primary, #101c16);
  font: var(--sprout-font-h5);
  margin: 0;
  min-width: 0;
  flex: 0 1 auto;
  white-space: nowrap;

  @media only screen and (max-width: 700px) {
    font: var(--sprout-font-h6);
  }
`;

const SubtitleWrapper = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1 1 auto;
  white-space: nowrap;
  overflow: hidden;

  @media only screen and (max-width: 700px) {
    white-space: normal;
    overflow: visible;
    flex-basis: 100%;
    width: 100%;
  }
`;

/* ----------------------------------
   Types
---------------------------------- */

interface ReviewAccordionTitleProps {
  title?: string;
  count?: number;
  onTitleClick?: () => void;
  Subtitle?: React.ComponentType | ReactNode;
  isOpen?: boolean;
  customTitle?: ReactNode;
  fullWidth?: boolean;
}

const ReviewAccordionTitle = ({
  title,
  count,
  onTitleClick,
  Subtitle,
  isOpen,
  customTitle,
  fullWidth
}: ReviewAccordionTitleProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <TitleWrapper
      onClick={onTitleClick}
      fullWidth={fullWidth}
      aria-expanded={isOpen}
    >
      <Titles>
        <Title>
          {customTitle !== undefined && customTitle !== null
            ? customTitle
            : t(title ?? '', { n: count })}
        </Title>

        {Subtitle ? (
          <SubtitleWrapper>
            {typeof Subtitle === 'function' ? (
              <Subtitle />
            ) : (
              Subtitle
            )}
          </SubtitleWrapper>
        ) : null}
      </Titles>
    </TitleWrapper>
  );
};

export default ReviewAccordionTitle;